import ModalCover from 'components/shared/modal/ModalCover';
import React from 'react';
import styles from './MfImportModal.module.css';
import MfImportSteps from './MfImportSteps';
import MfImportFile from './MfImportFile';
import useTheme from 'config/useTheme';
import MfAddComposition from './MfAddComposition';
import MfAuthorization from './MfAuthorization';
import { MfImportProvider, useMfImport } from 'features/compositions/context/MfImportContext';
import MfDataTransmission from './MfDataTransmission';

const MfImportModalInner = () => {
  const { dark } = useTheme();
  const { step } = useMfImport();

  return (
    <ModalCover size='lg' closeOnOverlay={[1, 2, 3].includes(step)}>
      <div className={`${styles.mf_modal} ${dark ? styles.dark : ''}`}>
        <h3>Upload a File</h3>
        <MfImportSteps />
        {step === 1 && <MfImportFile />}
        {step === 2 && <MfAddComposition />}
        {step === 3 && <MfAuthorization />}
        {step === 4 && <MfDataTransmission />}
      </div>
    </ModalCover>
  )
}

const MfImportModal = () => (
  <MfImportProvider>
    <MfImportModalInner />
  </MfImportProvider>
);

export default MfImportModal;